export enum OnboardingErrorType {
  InitialCrmFetch = "InitialCrmFetch",
  Save = "Save",
  Submit = "Submit",
  NdaFetch = "NdaFetch",
  StatusPolling = "StatusPolling",
  CountryValidationFetch = "CountryValidationFetch",
}

export type OnboardingError = {
  code: number;
  type: OnboardingErrorType;
  name?: string;
  message?: string;
  stack?: string;
};

export enum OnboardingErrorMessage {
  default = "defaultErrorMessage",
  invalidUrl = "invalidUrlErrorMessage",
}

export enum OnboardingServerErrorType {
  Authentication = "Authentication",
  InitialCrmFetch = "InitialCrmFetch",
  SaveGameConcept = "SaveGameConcept",
  GetFullIdAzureResponse = "GetFullIdAzureResponse",
  GetFullIdXboxResponse = "GetFullIdXboxResponse",
  GetFullPitchResponse = "GetFullPitchResponse",
  Get5x5Token = "Get5x5Token",
  FailedToCreateCRMEntity = "FailedToCreateCRMEntity",
  FailedToGetCRMEntity = "FailedToGetCRMEntity",
  FailedToUpdateCRMEntity = "FailedToUpdateCRMEntity",
  FailedToFindLogicalCollectionName = "FailedToFindLogicalCollectionName",
  CVSError = "CVSError",
  NDAError = "NDAError",
  OVDFError = "OVDFError",
  PartnerCenterTokenError = "PartnerCenterTokenError",
  PartnerCenterError = "PartnerCenterError",
  PartnerCenterEnrollmentError = "PartnerCenterEnrollmentError",
  PartnerCenterFileUploadError = "PartnerCenterFileUploadError",
  TLAError = "TLAError",
  RoleUpdateJobError = "RoleUpdateJobError",
  GetPaginatedConcepts = "GetPaginatedConcepts",
  AuthenticationError = "AuthenticationError",
  AccessToken = "AccessToken",
  FailedToGetAccessToken = "FailedToGetAccessToken",
  GetOptionSetChoices = "GetOptionSetChoices",
  FailedToFetchEntityDefinitions = "FailedToFetchEntityDefinitions",
  GetTrackingInfo = "GetTrackingInfo",
  UrlValidationError = "UrlValidationError",
  CreateContractError = "CreateContractError",
}
